/*
 * Universal Construct — TBI Bank rate calculator
 * Pure formula extracted from Calculatorgeneral.js (delivered by TBI partner).
 *
 * Exposes:
 *   window.UC.calculateTBI(amount, months) → { eligible, rata, total, perioada, ... }
 *   window.calplata()  // backward-compatible wrapper for the standalone calculator.html mockup
 *
 * The formula has 4 brackets keyed off the cart/product total in RON:
 *   100 – 2000      → 4 rate fixe egale, fără dobândă, fără asigurare (comision 40 RON)
 *   2000.01 – 5000  → dobândă 29%, comision 95 RON, asigurare 0.20%/lună
 *   5000.01 – 10000 → dobândă 24%, comision 95 RON, asigurare 0.20%/lună
 *   10000.01 – 60000 → dobândă 18%, comision 95 RON, asigurare 0.20%/lună
 */
(function () {
  'use strict';
  window.UC = window.UC || {};

  var BRACKETS = [
    { min: 100,      max: 2000,  dobanda: 0,    comision: 40, valasig: 0,      fixedPeriod: 4 },
    { min: 2000.01,  max: 5000,  dobanda: 0.29, comision: 95, valasig: 0.0020, fixedPeriod: null },
    { min: 5000.01,  max: 10000, dobanda: 0.24, comision: 95, valasig: 0.0020, fixedPeriod: null },
    { min: 10000.01, max: 60000, dobanda: 0.18, comision: 95, valasig: 0.0020, fixedPeriod: null }
  ];

  var MIN_AMOUNT = 100;
  var MAX_AMOUNT = 60000;
  var MAX_MONTHS = 60;  // perioada maximă admisă contractual de TBI pentru creditele >2000 RON

  function getBracket(amount) {
    for (var i = 0; i < BRACKETS.length; i++) {
      if (amount >= BRACKETS[i].min && amount <= BRACKETS[i].max) return BRACKETS[i];
    }
    return null;
  }

  function round2(n) { return Math.round(n * 100) / 100; }

  function computeIRR(cashflows, guess) {
    var maxIter = 100, precision = 1e-7;
    var rate = (typeof guess === 'number') ? guess : 0.1;
    for (var i = 0; i < maxIter; i++) {
      var npv = 0, d_npv = 0;
      for (var t = 0; t < cashflows.length; t++) {
        npv += cashflows[t] / Math.pow(1 + rate, t);
        if (t > 0) d_npv -= t * cashflows[t] / Math.pow(1 + rate, t + 1);
      }
      var newRate = rate - npv / d_npv;
      if (Math.abs(newRate - rate) < precision) return rate;
      rate = newRate;
    }
    return rate;
  }

  function computeDAE(amount, perioada, monthlyPayment) {
    var cashflows = [amount];
    if (amount < 2000.01) {
      for (var i = 1; i <= 4; i++) cashflows.push(-(amount + 40) / 4);
    } else {
      for (var j = 1; j <= perioada; j++) cashflows.push(-monthlyPayment);
    }
    var monthlyRate = computeIRR(cashflows);
    return (Math.pow(1 + monthlyRate, 12) - 1) * 100;
  }

  /**
   * Calculate TBI installment for a given amount.
   * @param {number} amount  — total in RON (e.g. cart total or product price)
   * @param {number} months  — requested period (ignored for ≤ 2000 RON, where 4 is forced)
   * @returns {object} { eligible, reason?, rata, total, perioada, asigurare, dobanda, comision, dae }
   */
  window.UC.calculateTBI = function (amount, months) {
    if (typeof amount !== 'number' || !isFinite(amount) || amount <= 0) {
      return { eligible: false, reason: 'invalid_amount' };
    }
    if (amount < MIN_AMOUNT) return { eligible: false, reason: 'below_min', min: MIN_AMOUNT };
    if (amount > MAX_AMOUNT) return { eligible: false, reason: 'above_max', max: MAX_AMOUNT };

    var bracket = getBracket(amount);
    if (!bracket) return { eligible: false, reason: 'no_bracket' };

    var perioada = bracket.fixedPeriod || (months || MAX_MONTHS);
    var asigurare = bracket.valasig * (amount + bracket.comision) * perioada;
    var rata, total;

    if (bracket.fixedPeriod) {
      rata = (amount + bracket.comision) / 4;
      total = amount + bracket.comision;
    } else {
      var principal = amount + bracket.comision + asigurare;
      var r = bracket.dobanda / 12;
      var x = Math.pow(1 + r, perioada);
      rata = principal * x * r / (x - 1);
      total = rata * perioada;
    }

    return {
      eligible: true,
      amount: amount,
      perioada: perioada,
      rata: round2(rata),
      total: round2(total),
      asigurare: round2(asigurare),
      dobanda: bracket.dobanda,
      comision: bracket.comision,
      dae: round2(computeDAE(amount, perioada, rata)),
      isVariablePeriod: !bracket.fixedPeriod  // true pentru bracketele >2000 unde perioada e configurabilă
    };
  };

  window.UC.TBI_MIN_AMOUNT = MIN_AMOUNT;
  window.UC.TBI_MAX_AMOUNT = MAX_AMOUNT;
  window.UC.TBI_MAX_MONTHS = MAX_MONTHS;

  /*
   * Backward-compatible wrapper for the standalone calculator.html mockup.
   * Keeps the original DOM IDs working (totalvalue, perioada, asigurare, dae, rata, totaldeplata).
   */
  window.calplata = function () {
    var amountEl = document.getElementById('totalvalue');
    var monthsEl = document.getElementById('perioada');
    if (!amountEl) return;
    var amount = parseFloat(amountEl.value);
    var months = monthsEl ? parseInt(monthsEl.value, 10) : 24;
    var result = window.UC.calculateTBI(amount, months);

    var resetIds = ['asigurare', 'dae', 'rata', 'totaldeplata'];
    if (!result.eligible) {
      resetIds.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.innerText = '0.00';
      });
      return;
    }
    var set = function (id, val) { var el = document.getElementById(id); if (el) el.innerText = val; };
    set('asigurare', result.asigurare.toFixed(2));
    set('dae', result.dae.toFixed(2));
    set('rata', result.rata.toFixed(2));
    set('totaldeplata', result.total.toFixed(2));
  };
})();
